import { render, staticRenderFns } from "./ALPS2023.vue?vue&type=template&id=bff8ba02&scoped=true"
import script from "./ALPS2023.vue?vue&type=script&lang=js"
export * from "./ALPS2023.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff8ba02",
  null
  
)

export default component.exports